import * as React from 'react';
import { Colors } from 'library';
import { Row, Text, Icon, Stack, Card, ResponsiveRow } from 'library/ui';
import { useHistory } from 'react-router';
import SignupForm from './SignUpForm';
import SignUpLoginTab from 'parent-portal/public/SignUpLoginTab';
import SignUpLoginHeader from 'parent-portal/public/SignUpLoginHeader';
import SignUpLoginContainer from 'parent-portal/public/SignUpLoginContainer';
import BusinessIcon from '@mui/icons-material/Business';
import SchoolIcon from '@mui/icons-material/School';
import TeacherDownloadCard from './TeacherDownloadCard';
import type { SvgIconComponent } from '@mui/icons-material';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type Role = 'program' | 'teacher' | null;

export default function SignUpPage() {
    const history = useHistory();
    const [role, setRole] = React.useState<Role>(null);

    const renderCard = (
        selected: boolean,
        icon: SvgIconComponent | IconDefinition,
        title: string,
        description: string,
        role: Role,
    ) => {
        return (
            <Card tone={selected ? 'secondary' : 'muted'} onClick={() => setRole(role)}>
                <Stack align="center" gap="sm" padding="none">
                    <Icon
                        size="lg"
                        icon={icon}
                        bgColor={selected ? Colors.secondary : Colors.fill}
                        iconColor={selected ? Colors.white : Colors.primary}
                    />
                    <Text weight="bold">{title}</Text>
                    <Text size="xs" tone="secondary">
                        {description}
                    </Text>
                </Stack>
            </Card>
        );
    };

    return (
        <SignUpLoginContainer>
            <Row justify="center" fullWidth>
                <Stack gap="md" maxWidth="md" fullWidth>
                    <Row justify="center" fullWidth>
                        <SignUpLoginTab />
                    </Row>
                    <SignUpLoginHeader>Create an Account</SignUpLoginHeader>
                    <Stack gap="md">
                        <Text weight="bold">I am a...</Text>
                        <ResponsiveRow collapseAt="md">
                            {renderCard(
                                role === 'program',
                                BusinessIcon,
                                'Childcare Program',
                                "I operate a childcare center and I'm looking for staff",
                                'program',
                            )}
                            {renderCard(
                                role === 'teacher',
                                SchoolIcon,
                                'Teacher',
                                "I'm a childcare professional looking for work",
                                'teacher',
                            )}
                        </ResponsiveRow>
                    </Stack>
                    {role === 'program' && (
                        <SignupForm
                            onComplete={() => history.push('/home')}
                            hideReferral={false}
                            businessSignup={true}
                            modal={false}
                            skipToPhone={false}
                            hideHeader={true}
                            onNotBusinessClick={() => {
                                setRole('teacher');
                                window.scrollTo(0, 0);
                            }}
                        />
                    )}
                    {role === 'teacher' && <TeacherDownloadCard />}
                </Stack>
            </Row>
        </SignUpLoginContainer>
    );
}
